export const SppCustomGroupEnum = {
  ADVANCED_MEASUREMENTS: "advancedMeasurements",
  DISTANCE: "distance",
  ANGLE: "angle",
};

export const SppGroupEnum = {
  OTHER: "Other Sagittal Parameters",
  PELVIS: "Pelvis",
  LUMBAR_LORDOSIS: "Lumbar Lordosis",
  THORACIC_KYPHOSIS: "Thoracic Kyphosis",
  SAGITTAL: "Sagittal Alignment",
  CERVICAL: "Cervical Parameters",
};

export const SppMacroGroupEnum = {
  SAGITTAL: "Sagittal Parameters",
  CORONAL: "Coronal Parameters",
  GLOBAL: "GAP - Global Alignment & Proportion",
  SAAS: "SAAS - Sagittal Age-Adjusted Score",
  SAGITTAL_SCHWAB: "Sagittal Schwab Modifiers",
  KEY: "Key Parameters",
  GENERAL: "General Parameters",
};

export const ParamNatureEnum = {
  SCORE: "score",
  CLASSIFICATION: "classification",
  INDEX: "index",
  MODIFIER: "modifier",
  ANGLE: "angle",
  DISTANCE: "distance",
};

export const TargetTypeEnum = {
  GAP: "gap",
  SAAS: "saas",
  CUSTOM: "custom",
  SAAS_CUSTOM: "saas_custom",
  GAP_CUSTOM: "gap_custom",
};

export const TargetSectionEnum = {
  VALUES: "values",
  SCORES: "scores",
  POINTS: "points",
  DEVIATION: "deviation",
};

export const ColorClassEnum = {
  RED: "red",
  GREEN: "green",
  YELLOW: "yellow",
  TRANSPARENT: "transparent",
};

export const ButtonStateEnum = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

// Helper arrays for easy access
export const DISPLAY_ONLY_PARAM_NATURES = [
  ParamNatureEnum.SCORE,
  ParamNatureEnum.CLASSIFICATION,
  ParamNatureEnum.INDEX,
  ParamNatureEnum.MODIFIER,
];

export const TARGET_TYPES_CONFIG = [
  { id: TargetTypeEnum.GAP, label: "GAP" },
  { id: TargetTypeEnum.SAAS, label: "SAAS" },
  { id: TargetTypeEnum.CUSTOM, label: "Custom", isCustom: true },
];

export const isCustomTargetType = targetType =>
  targetType === TargetTypeEnum.SAAS_CUSTOM ||
  targetType === TargetTypeEnum.GAP_CUSTOM;

export const getBaseTargetType = targetType => {
  if (
    targetType === TargetTypeEnum.SAAS ||
    targetType === TargetTypeEnum.SAAS_CUSTOM
  ) {
    return TargetTypeEnum.SAAS;
  }

  return TargetTypeEnum.GAP;
};

export const getCustomTargetTypeForBase = baseTargetType => {
  return baseTargetType === TargetTypeEnum.SAAS
    ? TargetTypeEnum.SAAS_CUSTOM
    : TargetTypeEnum.GAP_CUSTOM;
};

export const getTargetTypeDisplayLabel = targetType => {
  if (isCustomTargetType(targetType)) {
    return "CUST";
  }

  const baseType = getBaseTargetType(targetType);
  return baseType === TargetTypeEnum.SAAS ? "SAAS" : "GAP";
};
